<mat-tab-group
  (selectedTabChange)="checkIfFormActive()"
  #tabs
  class="activity-builder-tabs"
  mat-stretch-tabs="false"
  >
  <!-- Custom/Journal Activity -->
  <mat-tab
    #tab
    class="custom-activity-tab"
    [disabled]="tabs.selectedIndex !== 0 && editingActivity"
    >
    <ng-template mat-tab-label>
      <mat-icon svgIcon="customActivity"></mat-icon>
      Custom
    </ng-template>

    <ng-template matTabContent>
      <custom-activity-form
        [currentCustomActivityForm]="currentCustomActivityFormData"
        [activePrograms]="activePrograms"
        [activeEditions]="activeEditions"
        [isDistributor]="isDistributor"
        [subjectId]="subjectId"
        [userGUID]="userGUID"
        [editionId]="editionId"
        [activityFormValidity]="activityFormValidity"
        [editingActivity]="editingActivity"
                (setCustomActivityFormData)="
                    setCustomActivityFormDataFn($event)
                "
        (setActivityFormValidity)="setActivityFormValidityFn($event)"
      ></custom-activity-form>
    </ng-template>
  </mat-tab>

  <!-- Performance/Avenue -->
  @if (!isMathClass()) {
    <mat-tab
      #tab
      class="avenue-activity-tab"
      [disabled]="tabs.selectedIndex !== 2 && editingActivity"
      >
      <ng-template mat-tab-label>
        <mat-icon svgIcon="perform"></mat-icon>
        Performance
      </ng-template>
      <ng-template matTabContent>
        <avenue-form
            fxFlexFill
            [currentPerformActivityForm]="currentPerformActivityFormData"
            [activePrograms]="activePrograms"
            [activeEditions]="activeEditions"
            [isDistributor]="isDistributor"
            [subjectId]="subjectId"
            [userGUID]="userGUID"
            [editionId]="editionId"
            [editingActivity]="editingActivity"
            (setPerformActivityFormData)="setPerformActivityFormDataFn($event)"
            (setActivityFormValidity)="setActivityFormValidityFn($event)"
            >
          </avenue-form>
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
